import {
  START_SUBMIT_APPOINTMENT,
  SUCCESS_SUBMIT_APPOINTMENT,
  FAIL_SUBMIT_APPOINTMENT,
} from './types';
import { createAction, getActionList } from './action-utils';
import { submitAppointmentPayload } from 'ts/types/appointments.types';

const appointmentActions = {
  submitAppointment: (payload: submitAppointmentPayload) =>
    createAction(START_SUBMIT_APPOINTMENT, payload),
  successSubmitAppointment: (payload: any) =>
    createAction(SUCCESS_SUBMIT_APPOINTMENT, payload),
  failSubmitAppointment: (payload: string | Object) =>
    createAction(FAIL_SUBMIT_APPOINTMENT, payload),
};

export default appointmentActions;

const actionList = getActionList(appointmentActions);

export type AppointmentActionType = typeof actionList[number];
